import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DataExportService {
  public queryEndPoint = "query-api/DataExport";

  constructor(private http: HttpClient) {}

  getGroeimeterData = (schooljaar: string, wachtwoord: string) => {
    const headers = new HttpHeaders({
      "Content-Type": "multipart/form-data",
    });
    let body = new FormData();
    body.append("Schoolyear", schooljaar);
    body.append("Password", wachtwoord);

    return this.http
      .post(`${this.queryEndPoint}/DownloadGroeiMeterData`, body, {
        headers: headers,
        responseType: "blob",
      })
      .subscribe({
        next: (data) => {
          this.downLoadFile(data, data.type);
        },
        error: (error) => {
          console.error("error " + JSON.stringify(error));
        },
      });
  };

  getUsageData = (vanaf: string, tot: string, wachtwoord: string) => {
    const headers = new HttpHeaders({
      "Content-Type": "multipart/form-data",
    });
    let body = new FormData();
    body.append("From", vanaf);
    body.append("Until", tot);
    body.append("Password", wachtwoord);
    return this.http
      .post(`${this.queryEndPoint}/DownloadGroeiMeterUsageData`, body, {
        headers: headers,
        responseType: "blob",
      })
      .subscribe({
        next: (data) => {
          this.downLoadFile(data, data.type);
        },
        error: (error) => {
          console.log("error " + JSON.stringify(error));
        },
      });
  };

  downLoadFile = (response: any, type: string) => {
    let dataType = type;
    let binaryData = [];
    binaryData.push(response);
    let downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(
      new Blob(binaryData, { type: dataType })
    );
    downloadLink.setAttribute("download", "data");
    document.body.appendChild(downloadLink);
    downloadLink.click();
  };
}
